import TableWrapRowsBoot from './StockItems/TableWrapRowsBoot';
import * as CoreFns from './utilities/CoreFns';

function App(props) {

  var currentList = props.currentList;
  var ownVariables = props.ownVariables;

  var topUpRows = [];
  var ov = currentList.ov;
  if (ov){
    var ovKeys = CoreFns.sortedKeyList(ov);
    topUpRows = ovKeys.map((aKey, index)=>{
      var thisOV = ov[aKey];
      var type = CoreFns.convertSelectionToType(thisOV.t, currentList);
      var val = ownVariables[aKey];
      var valText = processText(val, type);
        return <tr><td>{thisOV.n}</td><td>{valText}</td></tr>
      })
  }
//
  function processText(val, type){
    if (type.t === 'ListType'){
      return '[' + val.map((aV, index)=>{return processText(aV, type.c)}).join(', ') + ']';
    }else if (type.t === 'UInteger' || type.t === 'Integer'){
      return val.toString();
    }else if (type.t === 'Object'){
      var pieces = type.c.map((aSub, index)=>{
        return aSub.n + ':' + processText(val[aSub.n], aSub.t)
      })        
      return '{' + pieces.join(', ') + '}'; 
    }else if (type.t === 'Boolean'){
      if (val){
        return 'true';
      }else{
        return 'false';
      }
    }else{
      return val;
    }
  }
//

  var clientOutput = null;
  var clientBreak = null;
  var clientHead = null;
  if (topUpRows.length === 0){
    clientHead = <h3>No Variables</h3>
  }else{
    clientHead = <h3>Variables</h3>
    clientBreak = <br/>
    clientOutput = <TableWrapRowsBoot rows={topUpRows} headerCells={['Name', 'Value']}/>
  }
          
    //
                        
  return <center><div className='container-fluid py-5' style={{backgroundColor:'white'}}><div className='row'><div className='col-12 mx-auto text-center'>
    {clientHead}
    {clientBreak}
    {clientOutput}
   </div></div></div></center>

}

export default App;
